import type { IWidgetComponentController } from "../IWidgetComponentController";

export class DummyWidgetComponentController implements IWidgetComponentController {
    public static $inject: string[] = [];

    public icon: string;

    public caption: string;

    public subCaption: string = null;

    public url: string;

    public isLoading: boolean;

    constructor() {
        this.icon = "building";
        this.caption = "Maincap";

        this.url = "#/sites";

        this.isLoading = true;
        this.subCaption = "subbie";
        this.isLoading = false;
    }
}
